import styled, { css } from 'styled-components'
import CardContainer from 'live/components/ui/CardContainer'
import { EmptyData } from '@intelie/ui'
export const StyledCardContainer = styled(CardContainer)`
    padding: 0;

    > header {
        > div:first-of-type {
            text-transform: uppercase;
        }
    }

    ${({ editing }) =>
        editing &&
        css`
            border: 1px solid ${({ theme }) => theme['brand-primary']};
            && {
                && {
                    opacity: 1;
                    pointer-events: all;
                }
            }

            > header {
                background-color: ${({ theme }) => theme['gray-lighter']};
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
            }
            > footer {
                border-bottom-left-radius: 3px;
                border-bottom-right-radius: 3px;
            }
        `}

    > * {
        padding: 13px 20px 14px;
    }

    .capitalize {
        text-transform: capitalize;
    }
`

export const Table = styled.div`
    margin-bottom: 32px;
`
export const Action = styled.div`
    align-items: baseline;
    display: none;
    justify-content: space-between;

    button {
        background: none;
        border: none;
        margin: 0;
        padding: 0;
    }

    & > *:not(:last-child) {
        margin: 0 10px 0 0;
    }

    .text-primary {
        color: ${({ theme }) => theme['link-button']} !important;
    }
`

export const BaseRow = styled.div`
    display: grid;
    grid-template-columns: 2fr 2fr 1fr 1fr 1fr 1fr 3fr;
    text-transform: uppercase;

    & > * {
        padding: 16px;
    }
`

export const HeadRow = styled(BaseRow)`
    border-bottom: 1px solid ${({ theme }) => theme['light-borders']};
    color: ${({ theme }) => theme.gray};
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 12px;
    user-select: none;

    & > * {
        align-items: center;
        display: flex;
    }
`

export const BodyRow = styled(BaseRow)`
    border-bottom: 1px solid ${({ theme }) => theme['full-page-background']};
    font-size: 13px;

    & > div {
        align-items: center;
        justify-content: center;
    }

    ul {
        list-style-type: decimal;
    }

    &:hover {
        background-color: var(--blue-200);

        & > a {
            color: var(--gray-800);
        }

        ${Action} {
            display: flex;
        }
    }
`

export const StyledEmptyData = styled(EmptyData)`
    height: 178px;
`
